import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { FormSection } from '@ksyos/design-system';
import type { BariPostDietConsultReportData } from '@common/validation/customControls/bariPost/bariPostDietConsultReport/v1/bariPostDietConsultReportSchemaV1';
import { ProcessActivityAssetsDropzone } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import {
    BooleanRadioGroupFormGroup,
    DateInputFormGroup,
    TextAreaFormGroup,
} from '../../processActivityFormGroupFields';

export function BariPostDietConsultReportEdit(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPostDietConsultReportData>();

    return (
        <FormSection>
            <DateInputFormGroup
                fieldKey="datum_consult"
                isRequired={true}
                label="Datum consult"
                maxDate={DateTime.now().format()}
            />

            <TextAreaFormGroup
                fieldKey="verslag_consult"
                isRequired={true}
                label="Verslag consult"
                placeholder="Typ je verslag..."
            />

            <BooleanRadioGroupFormGroup
                fieldKey="bijzonderheden"
                isRequired={true}
                label="Bijzonderheden"
                onChange={async (checked) =>
                    onChange(
                        {
                            bijzonderheden: checked,
                            bijzonderheden_omschrijving: null,
                        },
                        'bijzonderheden'
                    )
                }
                type="radio"
            />
            {data.bijzonderheden && (
                <TextAreaFormGroup
                    fieldKey="bijzonderheden_omschrijving"
                    isRequired={true}
                    label="Omschrijving bijzonderheden"
                    placeholder="Het is opvallend dat..."
                />
            )}
            <ProcessActivityAssetsDropzone label="Bestand(en)" />
        </FormSection>
    );
}
